import React from "react";
import { useNavigate } from "react-router-dom";

import pages from "../../../constants/pages";
import convertDate from "../../../utils/convertDate";
import { DataTable } from "../../../components";

export default function Table({ broadcasts }) {
  const navigate = useNavigate();

  const options = {
    sortOrder: {
      name: "created_at",
      direction: "desc",
    },
    onRowClick: (_, { dataIndex }) =>
      navigate(
        pages.reminderBroadcastDetails.route + broadcasts[dataIndex]._id
      ),
  };

  const columns = [
    {
      name: "_id",
      label: "Broadcast ID",
      options: {
        display: false,
        filter: true,
        customBodyRender: (value) => {
          return value
            ? value.slice(0, 15) + (value.length > 15 ? "..." : "")
            : "Not Available";
        },
      },
    },

    {
      name: "broadcast_name",
      label: "Broadcast Name",
      options: {
        customBodyRender: (value) => {
          return value ? value : "Not Available";
        },
      },
    },

    {
      name: "stages_count",
      label: "Stages Count",
      options: {
        customBodyRender: (value) => {
          return value;
        },
      },
    },

    {
      name: "created_at",
      label: "Created At",
      options: {
        customBodyRender: (value) => {
          return value ? convertDate(value) : "Not Available";
        },
      },
    },

    {
      name: "created_by",
      label: "Created By",
      options: {
        customBodyRender: (value) => {
          return value ? value : "Not Available";
        },
      },
    },
  ];

  return (
    <React.Fragment>
      <DataTable columns={columns} options={options} data={broadcasts} />
    </React.Fragment>
  );
}
